import { render, staticRenderFns } from "./task-designing.vue?vue&type=template&id=40a9bb88&scoped=true&"
import script from "./task-designing.vue?vue&type=script&lang=js&"
export * from "./task-designing.vue?vue&type=script&lang=js&"
import style0 from "./task-designing.vue?vue&type=style&index=0&id=40a9bb88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9bb88",
  null
  
)

export default component.exports